import styled, { css } from "styled-components";

export const SwitchWrapper = styled.div<{
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
}>`
  position: relative;

  ${({ ml }) =>
    ml &&
    typeof ml === "number" &&
    css`
      margin-left: ${ml}px;
    `}

  ${({ mr }) =>
    mr &&
    typeof mr === "number" &&
    css`
      margin-right: ${mr}px;
    `}

  ${({ mt }) =>
    mt &&
    typeof mt === "number" &&
    css`
      margin-top: ${mt}px;
    `}

  ${({ mb }) =>
    mb &&
    typeof mb === "number" &&
    css`
      margin-bottom: ${mb}px;
    `}
`;

export const SwitchBoxToggle = styled.label<{ disabled?: boolean }>`
  position: absolute;
  left: 0;
  width: 34px;
  height: 14px;
  border-radius: 15px;
  background: ${({ disabled }) => (disabled ? "#ccc" : "#bebebe")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &::after {
    content: "";
    display: block;
    border: 1px solid #bebebe;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: -4px;
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.COLORS.GREY : theme.COLORS.WHITE};
    box-shadow: ${({ disabled }) =>
      disabled ? "none" : "1px 3px 3px 1px rgba(0, 0, 0, 0.2)"};
    transition: 0.2s;
  }
`;

export const SwitchBox = styled.input<{ disabled?: boolean }>`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 34px;
  margin-right: 12px;

  &:checked + ${SwitchBoxToggle} {
    background-color: ${({ theme, disabled }) =>
      disabled ? "#ccc" : theme.COLORS.ACTION_BLUE};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      margin-left: 21px;
      transition: 0.2s;
    }
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
